const SurveyObj = {
    // Method will return array of complete surveys
    getList(listData, pinnedItems, unfinishedSurveyIds) {
        return {
            data: this.getSurveyListData(listData.data.data, pinnedItems, unfinishedSurveyIds),
        }
    },

    //Method to get survey list data
    getSurveyListData(data, pinnedItems, unfinishedSurveyIds) {
        let surveyListArray = []
        for (let i in data) {
            let object = this.getSurveyListObject(data[i], pinnedItems, unfinishedSurveyIds)
            surveyListArray.push(object)
        }
        return surveyListArray
    },

    // Method will return object for a survey list
    getSurveyListObject(listItem, pinnedItems, unfinishedSurveyIds) {
        return {
            in_survey_Id: listItem.in_survey_Id,
            in_survey_master_id: listItem.in_survey_master_id,
            in_survey_type: listItem.in_survey_type,
            st_survey_name: listItem.st_survey_name.trim(),
            in_total_response: listItem.in_total_response,
            in_versionno: listItem.in_versionno,
            in_loop_survey: listItem.in_loop_survey,
            in_audit: listItem.in_audit,
            in_question_flow: listItem.in_question_flow,
            dt_published_at: listItem.dt_published_at,
            dt_updated_at: listItem.dt_updated_at,
            md5_in_survey_Id: listItem.md5_in_survey_Id,
            in_status: listItem.in_status,
            in_response_setting: (listItem.survey_type_settings == null) ? [] : listItem.survey_type_settings[0].in_response_setting,
            survey_question_detail: this.getQuesData(listItem.survey_question_detail),
            survey_start_end_screen_detail: (listItem.survey_start_end_screen_detail !== null) ? this.getQuesData(listItem.survey_start_end_screen_detail) : [],

            isPinned: (pinnedItems !== null) ? (pinnedItems.indexOf(listItem.in_survey_Id) > -1) ? true : false : false,
            sentCount: 0,
            unsentCount: 0,
            isDrafted: false,
            lastResponseDate: "",
            unfinished: (unfinishedSurveyIds.length != 0) ? (unfinishedSurveyIds.indexOf(listItem.in_survey_Id) > -1 ? true : false) : false,
        }
    },

    //Method will return question data
    getQuesData(quesData) {
        let QuesArray = []
        for (let i in quesData) {
            let quesObj = this.getQuesObject(quesData[i])
            QuesArray.push(quesObj)
        }
        return QuesArray
    },

    // Method will return object for a Question
    getQuesObject(quesItem) {
        return {
            st_question_title: quesItem.st_question_title,
            in_question_number: quesItem.in_question_number,
            in_question_order: quesItem.in_question_order,
            in_question_type_id: quesItem.in_question_type_id,
            in_status: quesItem.in_status,
            // in_survey_Id: quesItem.in_survey_Id,
            in_question_master_id: quesItem.in_question_master_id,
            st_question_hint: quesItem.st_question_hint,
            in_address: quesItem.in_address,
            in_audit: quesItem.in_audit,
            in_date: quesItem.in_date,
            in_photo: quesItem.in_photo,
            question_type_details: {
                in_question_type_id: quesItem.question_type_details.in_question_type_id,
                in_question_name: quesItem.question_type_details.in_question_name
            },
            question_validation_details: this.getQuesValDetailData(quesItem.question_validation_details),
            skip_logic_master_details: this.getSkipLogicMaster(quesItem.skip_logic_master_details)
        }
    },

    //Method will return question detail validation data
    getQuesValDetailData(quesValDetailData) {
        let QuesValDetailArray = []
        for (let i in quesValDetailData) {
            let quesValDetailObj = this.getQuesValDetailObject(quesValDetailData[i])
            QuesValDetailArray.push(quesValDetailObj)
        }
        return QuesValDetailArray
    },

    // Method will return object for a Question detail validation
    getQuesValDetailObject(valData) {
        return {
            in_question_validation_id: valData.in_question_validation_id,
            in_question_master_id: valData.in_question_master_id,
            in_survey_question_validation_id: valData.in_survey_question_validation_id,
            question_answer_details: this.getQuesAnsData(valData.question_answer_details)
        }
    },

    //Method will return question answer data
    getQuesAnsData(quesAnsData) {
        let QuesAnsArray = []
        for (let i in quesAnsData) {
            let quesAnsObj = this.getQuesAnsObject(quesAnsData[i])
            QuesAnsArray.push(quesAnsObj)
        }
        return QuesAnsArray
    },

    // Method will return object for a question answer data
    getQuesAnsObject(valData) {
        return {
            in_order_number: valData.in_order_number,
            in_survey_question_answer_id: valData.in_survey_question_answer_id,
            in_question_master_id: valData.in_question_master_id,
            in_survey_question_validation_id: valData.in_survey_question_validation_id,
            st_answer_label: valData.st_answer_label,
            st_answer_text: valData.st_answer_text,
            st_regex_value: valData.st_regex_value,
            st_answer_score: valData.st_answer_score,
            st_longitude: valData.st_longitude,
            st_latitude: valData.st_latitude,
            s3_url_path: (valData.hasOwnProperty('s3_url_path')) ? valData.s3_url_path : "",
            s3_url_path_link: (valData.hasOwnProperty('s3_imagepath')) ? valData.s3_imagepath : "",
        }
    },

    //Method will return skip logic master details
    getSkipLogicMaster(skipMasterDetail) {
        let skipMasterDetailArray = []
        for (let i in skipMasterDetail) {
            let skipMasterDetailObj = this.getSkipLogicMasterObject(skipMasterDetail[i])
            skipMasterDetailArray.push(skipMasterDetailObj)
        }
        return skipMasterDetail
    },

    // Method will return object for skip logic master
    getSkipLogicMasterObject(valData) {
        return {
            "in_skiplogic_master_id": valData.in_skiplogic_master_id,
            "in_parent_question_id": valData.in_parent_question_id,
            "in_then_question_id": valData.in_then_question_id,
            "in_then_question_number": valData.in_then_question_number,
            "in_else_question_id": valData.in_else_question_id,
            "in_else_question_number": valData.in_else_question_number,
            "in_max_else_question_number": valData.in_max_else_question_number,
            "skip_logic_rule": this.getSkipLogicRule(valData.skip_logic_rule)
        }
    },

    //Method will return skip logic rule data
    getSkipLogicRule(skipRuleDetail) {
        let skipRuleDetailArray = []
        for (let i in skipRuleDetail) {
            let skipRuleDetailObj = this.getskipRuleObject(skipRuleDetail[i])
            skipRuleDetailArray.push(skipRuleDetailObj)
        }
        return skipRuleDetailArray
    },

    // Method will return object for skip rule
    getskipRuleObject(ruleData) {
        return {
            "in_skiplogic_rule_id": ruleData.in_skiplogic_rule_id,
            "in_skiplogic_master_id": ruleData.in_skiplogic_rule_id,
            "st_skiplogic_condition": ruleData.in_skiplogic_rule_id,
            "st_is_answer": ruleData.in_skiplogic_rule_id,
            "in_question_type_id": ruleData.in_skiplogic_rule_id,
            "skip_logic_rule_details": this.getSkipLogicRuleDetail(ruleData.skip_logic_rule_details)
        }
    },


    //Method will return skip logic rule details data
    getSkipLogicRuleDetail(skipLogicRuleDetail) {
        let skipLogicRuleDetailArray = []
        for (let i in skipLogicRuleDetail) {
            let skipLogicRuleDetailObj = this.getsSkipLogicRuleDetailObject(skipLogicRuleDetail[i])
            skipLogicRuleDetailArray.push(skipLogicRuleDetailObj)
        }
        return skipLogicRuleDetailArray
    },

    // Method will return object for skip logic rule detail 
    getsSkipLogicRuleDetailObject(detailData) {
        return {
            "in_skiplogic_rule_details_id": detailData.in_skiplogic_rule_details_id,
            "in_skiplogic_rule_id": detailData.in_skiplogic_rule_details_id,
            "st_answer_value": detailData.in_skiplogic_rule_details_id,
            "st_logical_condition": detailData.in_skiplogic_rule_details_id,
            "st_rule_type": detailData.in_skiplogic_rule_details_id,
            "in_question_master_id": detailData.in_skiplogic_rule_details_id
        }
    },

}

export default SurveyObj;


// WEBPACK FOOTER //
// ./src/assets/js/skipLogic/PrepareQuestions.js